import {
	Backdrop,
	Grow,
	Modal,
} from '@material-ui/core';
import $ from 'jquery';
import React, { useEffect, useState } from "react";
import { FormattedMessage, useIntl } from 'react-intl'
import Switch from "react-switch";
import * as Utils from '../../commons/utils/Utils';

const DATA_TO_EXPORT = {
	id: true,
	movil: true,
	serial: true,
	fechaInspeccion: true,
	usuario: true,
	posicion: true,
	psi: true,
	mediciones: true,
	estado: true
}

const handleInitSelectionsExport = () => {
	let dataInit = JSON.parse(JSON.stringify(DATA_TO_EXPORT))
	return dataInit
}

const LlantaInspeccionesGridExport = (props) => {
	const [loading, setLoading] = useState(false)
	const intl = useIntl()

	const [dataToExport, setDataToExport] = useState(handleInitSelectionsExport)

	const handleDataExport = (nombre)=>{
		const miState = {...dataToExport};
		switch (nombre) {
			case "id":
				miState.id = !miState.id;
				break;
			case "movil":
				miState.movil = !miState.movil;
				break; 
			case "serial":
				miState.serial = !miState.serial;
				break;
			case "fechaInspeccion":
				miState.fechaInspeccion = !miState.fechaInspeccion;
				break;
			case "usuario":
				miState.usuario = !miState.usuario;
				break;
			case "posicion":
				miState.posicion = !miState.posicion;
				break;
			case "psi":
				miState.psi = !miState.psi;
				break;
			case "mediciones":
				miState.mediciones = !miState.mediciones;
				break;
			case "estado":
				miState.estado = !miState.estado;
				break;
			}
		setDataToExport(miState);
	}

	const handleExportExcel = (event) => {
		let queryFilters = props.queryFilters();
		event.preventDefault()
		setLoading(true)
		let auxDataToExport = JSON.stringify({
		colsAExportar: dataToExport,
		
		})
		Utils.sendDataBlob(`/llantainspecciones/exportar-excel${queryFilters}`,'POST',auxDataToExport)
		.then(data => {
			let fileBlob = new File([data],'llanta-inspecciones.xlsx')
			let fileUrl = URL.createObjectURL(fileBlob);
			$("<a />", {
			href: fileUrl,
			download: "llanta-inspecciones.xlsx"
			}).appendTo("body").get(0).click();
		}).catch((err) => {
			console.log(err)
		}).finally(() => {
			props.handleClose();
			setLoading(false)
		})
	}

  return(
	<Modal open={props.open}
		closeAfterTransition
		BackdropComponent={Backdrop}
		BackdropProps={{
			timeout: 1000,
		}}
	>
		<Grow in={props.open}>
			<div className="" tabIndex="-1" id="export_modal" role="dialog">
				<div className="modal-xl modal-dialog" role="document">
					<div className="modal-content">
						<div className="modal-header bg-fleet">
							<h4 className="modal-title text-white"><i className="ft-download align-middle icon-modal-title"></i><FormattedMessage id="LlantaInspeccionesGridExport.render.export_modal.header_datos_generales" defaultMessage=" Exportar Llanta Inspecciones"/></h4>
							<button type="button" onClick={()=>props.handleClose()} className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
						</div>
						<div className="modal-body modal-grey modal-mh ovf-x-hidden">
							<div className="row">
								<div className="col-md-12">
									<form className="form form-horizontal">
										<div className="form-body">
												<div className="card pull-up">
													<div className="card-content">
														<div className="card-body">
															<h4 className="form-section">
																<i className="la la-columns"></i><FormattedMessage id="movilesGrid.render.export_modal.columns_to_export.header_columnas_a_exportar" defaultMessage=" Columnas a exportar"/>
															</h4>
															<div className="row">
																<div className="col-md-3" style={{ display: 'flex', alignItems: 'center', padding: '4px 0px' }}>
																	<label className="col-md-6 label-control col-form-label" htmlFor="id">
																		<FormattedMessage id="LlantaInspeccionesGridExport.render.export_modal.columns_to_export.label_id_inspeccion" defaultMessage="ID de la inspección" />:
																	</label>
																	<Switch
																		onChange={() => handleDataExport("id")}
																		checked={dataToExport["id"] ? true : false}
																		value={dataToExport["id"]}
																		id="id"
																		name="id"
																		offColor="#FF4961"
																		onColor="#28D094"
																		className="col-md-6 align-middle"
																	/>
																</div>
																<div className="col-md-3" style={{ display: 'flex', alignItems: 'center', padding: '4px 0px' }}>
																	<label className="col-md-6 label-control col-form-label" htmlFor="movil">
																		<FormattedMessage id="LlantaInspeccionesGridExport.render.export_modal.columns_to_export.label_vehiculo" defaultMessage="Vehículo asociado" />:
																	</label>
																	<Switch
																		onChange={() => handleDataExport("movil")}
																		checked={dataToExport["movil"] ? true : false}
																		value={dataToExport["movil"]}
																		id="movil"
																		name="movil"
																		offColor="#FF4961"
																		onColor="#28D094"
																		className="col-md-6 align-middle"
																	/>
																</div>
																<div className="col-md-3" style={{ display: 'flex', alignItems: 'center', padding: '4px 0px' }}>
																	<label className="col-md-6 label-control col-form-label" htmlFor="serial">
																		<FormattedMessage id="LlantaInspeccionesGridExport.render.export_modal.columns_to_export.label_serial" defaultMessage="Serial" />:
																	</label>
																	<Switch
																		onChange={() => handleDataExport("serial")}
																		checked={dataToExport["serial"] ? true : false}
																		value={dataToExport["serial"]}
																		id="serial"
																		name="serial"
																		offColor="#FF4961"
																		onColor="#28D094"
																		className="col-md-6 align-middle"
																	/>
																</div>
																<div className="col-md-3" style={{ display: 'flex', alignItems: 'center', padding: '4px 0px' }}>
																	<label className="col-md-6 label-control col-form-label" htmlFor="fechaHora">
																		<FormattedMessage id="LlantaInspeccionesGridExport.render.export_modal.columns_to_export.label_fecha" defaultMessage="Fecha" />:
																	</label>
																	<Switch
																		onChange={() => handleDataExport("fechaInspeccion")}
																		checked={dataToExport["fechaInspeccion"] ? true : false}
																		value={dataToExport["fechaInspeccion"]}
																		id="fechaInspeccion"
																		name="fechaInspeccion"
																		offColor="#FF4961"
																		onColor="#28D094"
																		className="col-md-6 align-middle"
																	/>
																</div>
																<div className="col-md-3" style={{ display: 'flex', alignItems: 'center', padding: '4px 0px' }}>
																	<label className="col-md-6 label-control col-form-label" htmlFor="usuario">
																		<FormattedMessage id="LlantaInspeccionesGridExport.render.export_modal.columns_to_export.label_usuario" defaultMessage="Usuario" />:
																	</label>
																	<Switch
																		onChange={() => handleDataExport("usuario")}
																		checked={dataToExport["usuario"] ? true : false}
																		value={dataToExport["usuario"]}
																		id="usuario"
																		name="usuario"
																		offColor="#FF4961"
																		onColor="#28D094"
																		className="col-md-6 align-middle"
																	/>
																</div>
																<div className="col-md-3" style={{ display: 'flex', alignItems: 'center', padding: '4px 0px' }}>
																	<label className="col-md-6 label-control col-form-label" htmlFor="posicion">
																		<FormattedMessage id="LlantaInspeccionesGridExport.render.export_modal.columns_to_export.label_posicion" defaultMessage="Posición" />:
																	</label>
																	<Switch
																		onChange={() => handleDataExport("posicion")}
																		checked={dataToExport["posicion"] ? true : false}
																		value={dataToExport["posicion"]}
																		id="posicion"
																		name="posicion"
																		offColor="#FF4961"
																		onColor="#28D094"
																		className="col-md-6 align-middle"
																	/>
																</div>
																<div className="col-md-3" style={{ display: 'flex', alignItems: 'center', padding: '4px 0px' }}>
																	<label className="col-md-6 label-control col-form-label" htmlFor="psi">
																		<FormattedMessage id="LlantaInspeccionesGridExport.render.export_modal.columns_to_export.label_psi" defaultMessage="PSI" />:
																	</label>
																	<Switch
																		onChange={() => handleDataExport("psi")}
																		checked={dataToExport["psi"] ? true : false}
																		value={dataToExport["psi"]}
																		id="psi"
																		name="psi"
																		offColor="#FF4961"
																		onColor="#28D094"
																		className="col-md-6 align-middle"
																	/>
																</div>
																<div className="col-md-3" style={{ display: 'flex', alignItems: 'center', padding: '4px 0px' }}>
																	<label className="col-md-6 label-control col-form-label" htmlFor="medidas">
																		<FormattedMessage id="LlantaInspeccionesGridExport.render.export_modal.columns_to_export.label_medidas" defaultMessage="Medidas" />:
																	</label>
																	<Switch
																		onChange={() => handleDataExport("mediciones")}
																		checked={dataToExport["mediciones"] ? true : false}
																		value={dataToExport["mediciones"]}
																		id="mediciones"
																		name="mediciones"
																		offColor="#FF4961"
																		onColor="#28D094"
																		className="col-md-6 align-middle"
																	/>
																</div>
																<div className="col-md-3" style={{ display: 'flex', alignItems: 'center', padding: '4px 0px' }}>
																	<label className="col-md-6 label-control col-form-label" htmlFor="estado">
																		<FormattedMessage id="LlantaInspeccionesGridExport.render.export_modal.columns_to_export.label_estado" defaultMessage="Estado" />:
																	</label>
																	<Switch
																		onChange={() => handleDataExport("estado")}
																		checked={dataToExport["estado"] ? true : false}
																		value={dataToExport["estado"]}
																		id="estado"
																		name="estado"
																		offColor="#FF4961"
																		onColor="#28D094"
																		className="col-md-6 align-middle"
																	/>
																</div>
															</div>
														</div>
													</div>
												</div>
											<div className="col-md-12 alert alert-info small" role="alert">
											<FormattedMessage id="movilesGrid.render.export_modal.esta_accion_puede_demorar_unos_minutos" defaultMessage="Esta acción puede demorar unos minutos."/>
											</div>
										</div> 
									</form>
								</div>
							</div>
						</div>
						<div className="modal-footer modal-grey">
							<button type="button" className="btn btn-default btn-fleet" onClick={(e)=>handleExportExcel(e)} ><i className={loading ? 'la la-spinner spinner' : 'fa fa-download'}></i><FormattedMessage id="movilesGrid.render.export_modal.finish_button.exportar_a_excel" defaultMessage=" Exportar a Excel"/></button>
							<button type="button" className="btn btn-danger" onClick={()=>props.handleClose()} ><i className="fa fa-times-circle"></i><FormattedMessage id="movilesGrid.render.export_modal.finish_button.cancelar" defaultMessage=" Cancelar"/></button>
						</div>
					</div>
				</div>
			</div>
		</Grow>
	</Modal>
  )
}

export default LlantaInspeccionesGridExport
